export default __webpack_public_path__ + "static/media/pickup.e21586ed.png";